package com.narbase.narnic.trial.utils.translations


val arabicMap = mapOf(
    "%s selected" to "%s محددة",
    "Don't just take our word for it\n listen to our clients" to "لا تكتفِ بكلامنا فقط\nاستمع إلى عملائنا",
    "See it in action" to "تعرف على بلسم ميديكو",
    "See how it works in 2 minutes and 45 seconds" to "شاهد كيف يعمل خلال دقيقتين و45 ثانية",
).mapKeys { it.key.toLowerCase() }